var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_973658_535)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5229 15.5229 20 10 20C4.47716 20 0 15.5229 0 10C0 4.47716 4.47716 0 10 0C15.5229 0 20 4.47716 20 10ZM10.8928 4.4941C10.8928 4.001 10.4931 3.60124 9.99996 3.60124C9.50684 3.60124 9.1071 4.001 9.1071 4.4941V5.43794C7.74813 5.48229 6.66007 6.59793 6.66007 7.96769C6.66007 9.15714 7.4883 10.1861 8.65029 10.4403L10.8132 10.9135C11.2455 11.008 11.5542 11.3915 11.5542 11.8347C11.5542 12.3556 11.1318 12.7778 10.6118 12.7778H9.38823C8.97929 12.7778 8.62899 12.5168 8.49919 12.1496C8.33486 11.6846 7.82474 11.441 7.35981 11.6053C6.89489 11.7696 6.65121 12.2797 6.81554 12.7447C7.15977 13.7186 8.04189 14.4401 9.1071 14.5491V15.506C9.1071 15.9991 9.50684 16.3989 9.99996 16.3989C10.4931 16.3989 10.8928 15.9991 10.8928 15.506V14.5491C12.2678 14.4084 13.3399 13.2461 13.3399 11.8347C13.3399 10.5529 12.4475 9.44303 11.1948 9.16899L9.03189 8.69586C8.68969 8.621 8.44579 8.31797 8.44579 7.96769C8.44579 7.55601 8.77951 7.22229 9.19119 7.22229H10.6118C10.8908 7.22229 11.1406 7.34241 11.3145 7.53666C11.3961 7.62791 11.4598 7.73439 11.5008 7.8505C11.6652 8.31543 12.1753 8.55911 12.6402 8.39479C13.1051 8.23046 13.3488 7.72034 13.1845 7.25541C13.0644 6.91561 12.8794 6.60753 12.6451 6.34573C12.2053 5.85439 11.5874 5.52216 10.8928 5.4509V4.4941Z",
    fill: "url(#paint0_linear_973658_535)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_973658_535",
    x1: 0.768571,
    y1: 1.61571,
    x2: 23.5629,
    y2: 14.4643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3B3B3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_973658_535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIconWhite);
export default __webpack_public_path__ + "static/media/dollar-icon-white.05392a418399e151f02c846149f5e4b1.svg";
export { ForwardRef as ReactComponent };